module.exports = __webpack_public_path__ + "static/img/100.3f8102d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/100.png
// module id = HFfy
// module chunks = 0